import React from 'react';
import { connect } from 'react-redux';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { PhotoEditWindow } from '@ff-os/shared-react/components/photo-edit/photo-edit-window/PhotoEditWindow';
import { Area } from '@ff-os/shared-utils/types/Area';
import { selectVariantById } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { selectGroupById } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { getCropAspectRatio } from '@ff-scene-plugins/photo-prints-shared/getCropAspectRatio';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectFilledPhotoById, selectFilterByPhotoId, selectUrlForPhotoById } from '../../../_redux-photos';
import { selectSizeByPhotoId } from '../../../_redux-sizes';
import { PhotoPrintEditPreview } from '../PhotoPrintEditPreview';

const _PhotoPrintCropWindow = ({
    photo, apply, close,
    size, imageSrc,
    filter, updateFilter,
    hasBorder
}: Props) => {

    const aspectRatio = getCropAspectRatio(size, photo, hasBorder);

    return (
        <PhotoEditWindow
            overlayUrl={imageSrc}
            imageSize={{ width: photo.width!, height: photo.height! }}
            activeCropBox={photo.crop}
            save={apply} close={close}
            aspectRatio={aspectRatio}
            autoFaceCenter={photo.autoFaceCenter}
            detections={photo.detections}
            filter={filter}
            updateFilter={updateFilter}>
            <AspectRatio width={photo.width} height={photo.height}>
                <PhotoPrintEditPreview photoId={photo.id} />
            </AspectRatio>
        </PhotoEditWindow>
    );
};

type OwnProps = {
    photoId: string;
    close: () => void;
};

type Props = OwnProps & {
    imageSrc: string;
    photo: PhotoPrintsJson.ProcessedPhoto;
    apply: (crop: Area) => void;
    size: PhotoPrintsJson.Size;
    filter: string | null;
    updateFilter: (filter: string | null) => void;
    hasBorder: boolean;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => {
    const photo = selectFilledPhotoById(state, ownProps.photoId)!;
    const group = selectGroupById(state, photo.groupId);
    const variant = group ? selectVariantById(state, group.variantId) : null;
    const hasPhotoFunBorder = group && typeof group.magicBorderId === 'string' && group.magicBorderId.trim() !== '';
    const hasBorder = Boolean(variant?.borderId !== "without-border" || hasPhotoFunBorder);
    
    return {
        imageSrc: selectUrlForPhotoById(state, ownProps.photoId)!,
        photo,
        size: selectSizeByPhotoId(state, ownProps.photoId)!,
        filter: selectFilterByPhotoId(state, ownProps.photoId)!,
        hasBorder
    };
};

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({

    apply: (crop: Area) => dispatch(photoActions.updateCrop({ photoId: ownProps.photoId, crop: crop })),

    updateFilter: (filter: string | null) =>
        dispatch(photoActions.updateFilter({ photoId: ownProps.photoId, filter: filter }))
});

export const PhotoPrintCropWindow = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PhotoPrintCropWindow);